"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiProvider = void 0;
var _auth = require("@ori/auth");
var _checkoutUtils = require("@ori/checkout-utils");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _jsxRuntime = require("react/jsx-runtime");
// TO-DO: Maybe move these into @ori/checkout-utils?
const timeout = 10000;
const swrConfig = {
  focusThrottleInterval: 300000,
  suspense: false,
  ..._checkoutUtils.basicSwrOptions
};
const ApiProvider = ({
  children
}) => {
  const {
    token
  } = (0, _auth.useToken)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    globalApiUrl,
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['globalApi', 'staticApi']);
  const globalClientProps = {
    baseUrl: globalApiUrl,
    language,
    tenant,
    timeout,
    token
  };
  const staticClientProps = {
    baseUrl: staticApiUrl,
    language,
    tenant,
    timeout
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_fetching.SWRConfig, {
    value: swrConfig,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_globalApiClientReact.ApiClientProvider, {
      ...globalClientProps,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_staticApiClientReact.ApiClientProvider, {
        ...staticClientProps,
        children: children
      })
    })
  });
};
exports.ApiProvider = ApiProvider;